import ReviewForm from './review-form-view'

export default ReviewForm
